// extracted by mini-css-extract-plugin
module.exports = {"maya_bg_page":"maya-bg-page_maya_bg_page__9P5uA","bg_top":"maya-bg-page_bg_top__3qn0a","bg_bottom":"maya-bg-page_bg_bottom__HG9zY"};